import React from "react";

import cx from "classnames";

import { default as DocumentTitle } from "~/lib/title";

import styles from "./Page.module.css";

type DivProps = React.HTMLProps<HTMLDivElement>;
type HeadingProps = React.HTMLProps<HTMLHeadingElement>;
type ElementProps = React.HTMLProps<HTMLElement>;

type HeaderActionsProps = React.PropsWithChildren<DivProps>;

export function HeaderActions({ children, className, ...rest }: HeaderActionsProps): React.ReactElement {
	return (
		<div className={cx(styles.headerActions, className)} {...rest}>
			{children}
		</div>
	);
}
HeaderActions.displayName = "Page.HeaderActions";

type TitleProps = React.PropsWithChildren<HeadingProps>;

export function Title({ children, className, ...rest }: TitleProps): React.ReactElement {
	return (
		<h1 className={cx(styles.headerTitle, className)} {...rest}>
			{children}
		</h1>
	);
}
Title.displayName = "Page.Title";

type HeaderProps = React.PropsWithChildren<ElementProps> & {
	noBottomBorder?: boolean;
	sticky?: boolean;
};

export function Header({ children, className, noBottomBorder, sticky, ...rest }: HeaderProps) {
	return (
		<header
			className={cx(
				styles.header,
				{ [styles.headerBorder]: !noBottomBorder, [styles.stickyHeader]: sticky },
				className,
			)}
			{...rest}
		>
			{children}
		</header>
	);
}
Header.displayName = "Page.Header";

type BodyProps = React.PropsWithChildren<DivProps>;

export const Body = ({ children, className, ...rest }: BodyProps) => {
	return (
		<div className={cx(styles.body, className)} {...rest}>
			{children}
		</div>
	);
};
Body.displayName = "Page.Body";

type PageProps = React.PropsWithChildren<ElementProps> & {
	title?: string;
	className?: string;
};

export class Page extends React.Component<PageProps> {
	static Header = Header;
	static Title = Title;
	static HeaderActions = HeaderActions;
	static Body = Body;

	constructor(props: PageProps) {
		super(props);
	}

	render() {
		const { title, className, children } = this.props;
		return (
			<>
				{title && <DocumentTitle title={title} />}
				<div className={cx(styles.page, className)}>{children}</div>
			</>
		);
	}
}
